import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7pc49wmqv: FaireProductEntity = {
  token: "p_m7pc49wmqv",
  type: "product",
  name: "Remi Cat- Organic Fine Knit Stuffed Animal Baby Toy",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/a382a4a538638028a06bfbdc39238722c7be0055e48328786211e62bced79b4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ddbc6e615fdd4d350104dea94f6780b4695a7149c9922285f7991d5d69379e3.jpeg",
    "https://cdn.faire.com/fastly/7aa9a98dd6f8b854c72c0842fd2306767af1189cb671d380bc85cfb247a51f70.jpeg",
    "https://cdn.faire.com/fastly/b6d236ad423c164b2262e7fc21043ed8fc9be2abae5e00ac120b8b33cab79ffc.jpeg",
    "https://cdn.faire.com/fastly/591bf09bbd1c816fa864dd9403c0f33dceb36395698c5e71dab442825b020d8c.jpeg",
    "https://cdn.faire.com/fastly/26cd233c7e9fa69e874db11de561d25fc8aed86ce3119e0fcf20c2244a4f7e6e.jpeg",
    "https://cdn.faire.com/fastly/b2110dc9e3fca15fc910322350169f753c364e56101c3e6b5002f1e91f7ecb3e.jpeg",
    "https://cdn.faire.com/fastly/4487b96dd7574368164a9bab9aa1529916f81ef33ca98fa08995a43a34f87d4a.jpeg",
    "https://cdn.faire.com/fastly/0cdd1d33ebded0bf7a216311d57cc36ceeae44848b810f0c04b0cbf5c852e036.jpeg",
    "https://cdn.faire.com/fastly/c3581c5aa3871f44a7c80575d1e9c7c5f42513a04644c99d4a53fc0960b1de0e.jpeg",
    "https://cdn.faire.com/fastly/8c6c4a237839a11b5eca6604b593b12064e96dcfb4b6f80e098abebad828f71b.jpeg",
    "https://cdn.faire.com/fastly/f243796789ea16e584ad1210d6d62ed8d0fa60ab87e611a6c4c3f26fa2662436.jpeg",
    "https://cdn.faire.com/fastly/df60385c1260c87e0c2bdf6a8559be31a34d15b9ec6d42234a59113361efde95.jpeg",
    "https://cdn.faire.com/fastly/c9b937ca1ad91a8d458546a028566b5c9bc9fe1483abdf6c69e4bf6035731933.jpeg",
    "https://cdn.faire.com/fastly/fdfd2fb68564e7dab89d71a9304c91eb3d233788a669e360b1b5124ba2f98113.jpeg",
  ],
  priceDollars: 20,
  description:
    '(Big Head Toys Collection)\nRemi, the Cat Explorer loves sailing, always on the prowl for adventures. Remi would like to sail around the entire globe one day.\n100% organic cotton outer shell, and poly-fill on the inside.\nAprox. Size: 11" x 7"\nWeight: 4 oz\nFor babies, kids & adults, 8 months and up.\n\nVIVERANO Organic Toys:\nQuirky & cuddly collection of organic cotton knit toys for your precious little ones.\nFresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\nLovingly made by hand using certified organic cotton, safe for hugging & snuggling.\nHeirloom quality, meticulous construction and attention to detail.\nNon-toxic and eco-friendly materials.\nSlight color variations & imperfections may exist making each handmade piece charming and one-of-a-kind.\nEasy care machine washable with cool water and non-toxic detergent, fluff in the dryer for a few minutes and then air dry.\nEthically handcrafted by artisans at a GOTS certified facility in India.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:31.196Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
